"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelDisbursementMutation = exports.useUpdateScheduledDateMutation = exports.useUpdateMobileNumberMutation = exports.useRetryDisbursementMutation = exports.useGetFailedDisbursementsQuery = exports.useGetDeliveredDisbursementsQuery = exports.useGetQueueStatusQuery = exports.useProcessDueDisbursementsMutation = exports.useGetDueDisbursementsQuery = exports.useGetDisbursementStatisticsQuery = exports.useGetDisbursementQuery = exports.useLazyGetDisbursementsQuery = exports.useGetDisbursementsQuery = exports.disbursementsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var stock_1 = require("./stock");
exports.disbursementsApi = (0, react_1.createApi)({
    reducerPath: "disbursementsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Disbursements"],
    endpoints: function (builder) { return ({
        getDisbursements: builder.query({
            query: function (params) { return ({
                url: "/v1/disbursements",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                return ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.disbursements)
                    ? __spreadArray(__spreadArray([], result.content.disbursements.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Disbursements",
                            id: _id,
                        });
                    }), true), [
                        { type: "Disbursements", id: "LIST" },
                    ], false) : [{ type: "Disbursements", id: "LIST" }];
            },
        }),
        getDisbursement: builder.query({
            query: function (id) { return "/v1/disbursements/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Disbursements", id: id }]; },
        }),
        getDisbursementStatistics: builder.query({
            query: function (params) { return ({
                url: "/v1/disbursements/statistics",
                params: params,
            }); },
        }),
        getDueDisbursements: builder.query({
            query: function (params) { return ({
                url: "/v1/disbursements/due",
                params: params,
            }); },
            providesTags: [{ type: "Disbursements", id: "DUE" }],
        }),
        processDueDisbursements: builder.mutation({
            query: function () { return ({
                url: "/v1/disbursements/process-due",
                method: "POST",
            }); },
            invalidatesTags: [
                { type: "Disbursements", id: "LIST" },
                { type: "Disbursements", id: "DUE" },
            ],
        }),
        getQueueStatus: builder.query({
            query: function () { return "/v1/disbursements/queue"; },
        }),
        getDeliveredDisbursements: builder.query({
            query: function (params) { return ({
                url: "/v1/disbursements/delivered",
                params: params,
            }); },
        }),
        getFailedDisbursements: builder.query({
            query: function (params) { return ({
                url: "/v1/disbursements/failed",
                params: params,
            }); },
            providesTags: [{ type: "Disbursements", id: "FAILED" }],
        }),
        retryDisbursement: builder.mutation({
            query: function (_a) {
                var id = _a.id, _b = _a.mode, mode = _b === void 0 ? "new" : _b;
                return ({
                    url: "/v1/disbursements/".concat(id, "/retry"),
                    method: "POST",
                    body: { mode: mode },
                });
            },
            invalidatesTags: function (_result, _error, _a) {
                var id = _a.id;
                return [
                    { type: "Disbursements", id: id },
                    { type: "Disbursements", id: "LIST" },
                    { type: "Disbursements", id: "FAILED" },
                ];
            },
        }),
        updateMobileNumber: builder.mutation({
            query: function (_a) {
                var id = _a.id, mobile_number = _a.mobile_number;
                return ({
                    url: "/v1/disbursements/".concat(id, "/update-mobile"),
                    method: "POST",
                    body: { mobile_number: mobile_number },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Disbursements", id: id },
                    { type: "Disbursements", id: "FAILED" },
                ];
            },
        }),
        updateScheduledDate: builder.mutation({
            query: function (_a) {
                var id = _a.id, scheduled_date = _a.scheduled_date;
                return ({
                    url: "/v1/disbursements/".concat(id, "/update-scheduled-date"),
                    method: "POST",
                    body: { scheduled_date: scheduled_date },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Disbursements", id: id },
                    { type: "Disbursements", id: "LIST" },
                ];
            },
            // Invalidate stock cache when scheduled date is updated (may assign voucher)
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(stock_1.stockApi.util.invalidateTags([{ type: "Stock", id: "SUMMARY" }]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        cancelDisbursement: builder.mutation({
            query: function (_a) {
                var id = _a.id, reason = _a.reason;
                return ({
                    url: "/v1/disbursements/".concat(id, "/cancel"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Disbursements", id: id },
                    { type: "Disbursements", id: "LIST" },
                ];
            },
            // Invalidate stock cache when disbursement is cancelled (voucher released)
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(stock_1.stockApi.util.invalidateTags([{ type: "Stock", id: "SUMMARY" }]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
    }); },
});
exports.useGetDisbursementsQuery = exports.disbursementsApi.useGetDisbursementsQuery, exports.useLazyGetDisbursementsQuery = exports.disbursementsApi.useLazyGetDisbursementsQuery, exports.useGetDisbursementQuery = exports.disbursementsApi.useGetDisbursementQuery, exports.useGetDisbursementStatisticsQuery = exports.disbursementsApi.useGetDisbursementStatisticsQuery, exports.useGetDueDisbursementsQuery = exports.disbursementsApi.useGetDueDisbursementsQuery, exports.useProcessDueDisbursementsMutation = exports.disbursementsApi.useProcessDueDisbursementsMutation, exports.useGetQueueStatusQuery = exports.disbursementsApi.useGetQueueStatusQuery, exports.useGetDeliveredDisbursementsQuery = exports.disbursementsApi.useGetDeliveredDisbursementsQuery, exports.useGetFailedDisbursementsQuery = exports.disbursementsApi.useGetFailedDisbursementsQuery, exports.useRetryDisbursementMutation = exports.disbursementsApi.useRetryDisbursementMutation, exports.useUpdateMobileNumberMutation = exports.disbursementsApi.useUpdateMobileNumberMutation, exports.useUpdateScheduledDateMutation = exports.disbursementsApi.useUpdateScheduledDateMutation, exports.useCancelDisbursementMutation = exports.disbursementsApi.useCancelDisbursementMutation;
